import axios from '@/libs/api.request'

export const login = (userName, password) => {
  const data = {
    userName,
    password
  }
  return axios.request({
    url: 'login',
    data,
    method: 'post'
  })
}

export const getUserInfo = () => {
  return axios.request({
    url: 'userinfo',
    method: 'get'
  })
}

export const logout = () => {
  return axios.request({
    url: 'logout',
    method: 'post'
  })
}

export const getUserList = ({ page, perPage }) => {
  const data = {
    page,
    perPage
  }
  return axios.request({
    url: 'user/list',
    data,
    method: 'post'
  })
}

export const getUser = (id) => {
  return axios.request({
    url: 'user/' + id,
    method: 'get'
  })
}

export const addUser = (userName, name, email, password, roles) => {
  const data = {
    userName,
    name,
    email,
    password,
    roles
  }
  return axios.request({
    url: 'user/add',
    data,
    method: 'post'
  })
}

export const deleteUser = (id) => {
  return axios.request({
    url: 'user/' + id,
    method: 'delete'
  })
}

export const modifyUser = (id, name, email, password, roles) => {
  const data = {
    name,
    email,
    password,
    roles
  }
  return axios.request({
    url: 'user/' + id,
    data,
    method: 'post'
  })
}

export const setUser = (id, name, pwd, pwd1) => {
  let data = {
    name,
    pwd,
    pwd1
  }
  return axios.request({
    url: 'user/set/' + id,
    data,
    method: 'post'
  })
}
export const setUserAccess = (id, access) => {
  const data = {
    access
  }
  return axios.request({
    url: 'user/' + id + '/roles',
    data,
    method: 'put'
  })
}
